import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { isMobile } from 'react-device-detect';
import { pushPurchaseDataLayer,pushUserIdToDataLayer } from '../../utils/analytics.js';

//redux
import { connect } from 'react-redux';
import { cleanRedux } from '../../action/anueInfoAction';
//config
import config from '../../config';
class PurchaseComplete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ALTAmt: 0,
            ALTFee: 0,
            RSPAmt: 0,
            RSPFee: 0,
            completeData: undefined,
            selectGdName: undefined,
            selectAccount: undefined,
            selectContext: undefined,
            selectInvDay: undefined,
            selectPromText: undefined,
            selectNextDay: undefined
        }
    }

    componentWillMount() {
        document.documentElement.scrollTop = 0;
        if (this.props.isLogin === "N") {
            this.props.history.push("/Login");
        } else {
            let ALTAmt = 0; let ALTFee = 0; let RSPAmt = 0; let RSPFee = 0;
            for (let i = 0; i <= this.props.completeData.length - 1; i++) {
                ALTAmt += parseFloat(this.props.completeData[i].alT_Amt);
                RSPAmt += parseFloat(this.props.completeData[i].rsP_Amt);
                ALTFee += parseFloat(this.props.completeData[i].alT_Fee);
                RSPFee += parseFloat(this.props.completeData[i].rsP_Fee);
            }

            this.setState({
                ALTAmt: ALTAmt,
                ALTFee: ALTFee,
                RSPAmt: isNaN(RSPAmt) === true ? undefined : RSPAmt,
                RSPFee: isNaN(RSPFee) === true ? undefined : RSPFee,
                completeData: this.props.completeData,
                selectGdName: this.props.selectGdName,
                selectAccount: this.props.selectAccount,
                selectContext: this.props.selectContext,
                selectInvDay: this.props.selectInvDay,
                selectPromText: this.props.selectPromText,
                selectNextDay: this.props.selectNextDay,
            }, () => {
                this.props.cleanRedux();
            });
            pushUserIdToDataLayer();  //登入
            
        }
    }

    componentDidMount(){
        pushPurchaseDataLayer(this.props.gid,this.props.gdName,(this.state.ALTAmt+this.state.RSPAmt),(this.state.ALTFee+this.state.RSPFee),(this.state.selectAccount.selAcctType === "acctT" ? "台幣" : "美金"));
    }

    purchaseAgain() {
        this.props.history.push("/Login");
    }

    goSearch() {
        window.location.href ="../../../EC/member/order-check";
    }

    render() {
        return <div className="anueContainer combinationContainer">
            <div className="combinationSub">申購您的投資組合</div>
            <div className="combinationTitle">
                <div className="titleFont">{this.state.selectGdName}
                </div>
            </div>
            <div className="progressIndex">
                <div className="progressItem done">
                    <h5><i>1</i><span>申購確認</span></h5>
                </div>
                <div className="progressItem active">
                    <h5><i>2</i><span>申購完成</span></h5>
                </div>
            </div>
            <h3 className="comfirmTitle">申購基金明細</h3>
            <div className="comfirmBox withSum">
                {
                    this.state.completeData !== undefined ?
                        this.state.completeData.map(({ mktName, fundPercent, fundID, fundName, alT_Amt, alT_Fee, rsP_Amt, rsP_Fee }) => {
                            return <div>
                                <div className="combinationName">
                                    <h5>{mktName}</h5>
                                    <div className="tag">{fundPercent * 100}%</div>
                                </div>
                                <div className="fundDetail head">
                                    <h4>{"（" + fundID + "）" + fundName}</h4>
                                </div>
                                <div className="fundDetail foot">
                                    <div style={{ flex: rsP_Amt ? "0 0 25%" : "0 0 50%" }}>
                                        <div className="gap">
                                            <div className="priceItem">
                                                <h5>單筆</h5>
                                                <div className="price">{config.format_with_substring(parseFloat(alT_Amt))}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ flex: rsP_Amt ? "0 0 25%" : "0 0 50%" }}>
                                        <div className="gap">
                                            <div className="priceItem">
                                                <h5>單筆手續費</h5>
                                                <div className="price">{parseFloat(alT_Fee)}</div>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        rsP_Amt ? <div style={{ flex: "0 0 25%" }}>
                                            <div className="gap">
                                                <div className="priceItem">
                                                    <h5>定額</h5>
                                                    <div className="price">{config.format_with_substring(parseFloat(rsP_Amt))}</div>
                                                </div>
                                            </div>
                                        </div> : ""
                                    }
                                    {
                                        rsP_Fee ? <div style={{ flex: "0 0 25%" }}>
                                            <div className="gap">
                                                <div className="priceItem">
                                                    <h5>定額手續費</h5>
                                                    <div className="price">{parseFloat(rsP_Fee)}</div>
                                                </div>
                                            </div>
                                        </div> : ""

                                    }
                                </div>
                            </div>
                        }) : ""
                }
                <div className="fullWidth" style={{ marginTop: "30px" }}>
                    <h4>合計</h4>
                    <div className="sumContainer">
                        <div>
                            <div className="gap">
                                <div className="priceItem">
                                    <h5>單筆</h5>
                                    <div className="price">{config.format_with_substring(Number(this.state.ALTAmt))}</div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="gap">
                                <div className="priceItem">
                                    <h5>單筆手續費</h5>
                                    <div className="price">{this.state.ALTFee}</div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.RSPAmt !== undefined ? <div>
                                <div className="gap">
                                    <div className="priceItem">
                                        <h5>定額</h5>
                                        <div className="price">{config.format_with_substring(Number(this.state.RSPAmt))}</div>
                                    </div>
                                </div>
                            </div> : ""
                        }
                        {
                            this.state.RSPFee !== undefined ? <div>
                                <div className="gap">
                                    <div className="priceItem">
                                        <h5>定額手續費</h5>
                                        <div className="price">{this.state.RSPFee}</div>
                                    </div>
                                </div>
                            </div> : ""
                        }
                    </div>
                </div>
            </div>
            <h3 className="comfirmTitle">扣款帳號</h3>
            <div className="comfirmBox">
                <div className="calFlexbox fullWidth">
                    <div>
                        <div className="inputGroup">
                            <label>交易幣別</label>
                            <div className="infoContainer">
                                <p>
                                    {
                                        this.state.selectAccount.selAcctType === "acctT" ? "台幣" : "美金"
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="calFlexbox fullWidth">
                    <div>
                        <div className="inputGroup">
                            <label>扣款帳號</label>
                            <div className="infoContainer">
                                <p>銀行：{this.state.selectAccount.bankCodeDesc}</p>
                                <p>帳號：{this.state.selectAccount.accNo}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="calFlexbox">
                    <div>
                        <div className="gap">
                            <div className="inputGroup">
                                <label>單筆投資</label>
                                <div className="inputText">{config.format_with_substring(this.state.ALTAmt + this.state.ALTFee)}</div>
                            </div>
                        </div>
                    </div>
                    {
                        Object.keys(this.state.selectInvDay).length !== 0 ?
                            <div>
                                <div className="gap">
                                    <div className="inputGroup">
                                        <label>定期定額</label>
                                        <div className="inputText">{config.format_with_substring(this.state.RSPAmt + this.state.RSPFee)}</div>
                                    </div>
                                </div>
                            </div> : ""
                    }
                </div>
                {
                    Object.keys(this.state.selectInvDay).length !== 0 ?
                        <div className="calFlexbox fullWidth">
                            <div>
                                <div className="inputGroup">
                                    <label>定期定額扣款日</label>
                                    <div className="infoContainer">
                                        {
                                            this.state.selectInvDay.map((value, index) => {
                                                return <p key={index}>每月{value.invDay}日(預計扣款日{value.nextDay})</p>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div> : ""
                }
                {
                    Object.keys(this.state.selectInvDay).length !== 0 ?
                        <div className="calFlexbox">
                            <div>
                                <div className="inputGroup inlineRadios">
                                </div>
                            </div>
                        </div> : ""
                }
                <div className="calFlexbox fullWidth">
                    <div>
                        <div className="inputGroup">
                            <label>優惠活動</label>
                            <div className="infoContainer">
                                <p>{this.state.selectPromText}%</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="buttonContainer done">
                <button className="btn btn-third round" id="prevBtn" onClick={() => { this.goSearch() }}>今日委託查詢/取消</button>
                <button className="btn btn-primary round main" id="nextBtn" onClick={() => { this.purchaseAgain() }}>繼續下單</button>
            </div>
        </div>
    }
}
function mapStateToProps(state) {
    return {
        isLogin: state.anueInfoState.isLogin,
        completeData: state.anueInfoState.completeData,
        selectGdName: state.anueInfoState.selectGdName,
        selectAccount: state.anueInfoState.selectAccount,
        selectContext: state.anueInfoState.selectContext,
        selectInvDay: state.anueInfoState.selectInvDay,
        selectPromText: state.anueInfoState.selectPromText,
    };
}

export default connect(mapStateToProps, { cleanRedux })(withRouter(PurchaseComplete));